export interface TranslatedString {
  en?: string;
  fr?: string;
  es?: string;
}

export enum TranslatedLanguage {
  en = 'en',
  fr = 'fr',
  es = 'es',
}

export enum Languages {
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  SPANISH = 'SPANISH',
}

export type Language = 'EN' | 'FR' | 'ES';
